import styled from '@emotion/styled';
import { Button, Chip, theme } from '@travelnest/hui';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { InfoCard } from '../info-card/InfoCard';
import StyledHeading from '../typography/StyledHeading';
import StyledText from '../typography/StyledText';

const PromptContainer = styled.div`
	margin: 0 0 16px 0;
`;

const HeadingContainer = styled.div`
  align-items: start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 0 8px 0;
  width:100%;
`;

const StyledTitle = styled(StyledHeading)`
	color: ${theme.colors.LM_NU100};
	margin: 0;
`;

const StyledParagraph = styled(StyledText)`
	color: ${theme.colors.LM_NU70T};
	margin: 0;
`;

interface IActionCardProps {
	heading: string;
	paragraph: string;
	chipText?: string;
	actionText: string;
	actionLink: string;
}

export const ActionCard: React.FC<IActionCardProps> = ({ heading, paragraph, chipText, actionText, actionLink }) => {
	const navigate = useNavigate();

	return (
		<InfoCard data-testid="action-card">
			<PromptContainer>
				<HeadingContainer>
					<StyledTitle type="IB110" lineHeight="sm" htmlElement="h4">
						{heading}
					</StyledTitle>
					{chipText && <Chip text={chipText} />}
				</HeadingContainer>
				<StyledParagraph type="IR100" lineHeight="md">
					{paragraph}
				</StyledParagraph>
			</PromptContainer>
			<div>
				<Button
					text={actionText}
					fill="light"
					size="regular"
					onClick={() => {
						(actionLink.includes('direct'))
							? window.location.href = process.env.DIRECT_HUB_URL ? process.env.DIRECT_HUB_URL : 'https://account-dev.travelnest.com/direct'
							: navigate(actionLink);
					}}
				/>
			</div>
		</InfoCard>
	);
};
